import React, { ReactNode } from "react";
import { Container, Row, Col } from "react-bootstrap";

// Define the props interface
interface MainContainerProps {
  children: ReactNode; // Ensures that children can be any valid React element
}

const MainContainer: React.FC<MainContainerProps> = ({ children }) => {
  return (
    <Container fluid className="p-4">
      <Row>
        <Col xs={12} md={8} className="mx-auto">
          {children}
        </Col>
      </Row>
    </Container>
  );
};

export default MainContainer;